// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount___6PkQ","list":"BalanceDue_list__3ahGt","listRow":"BalanceDue_listRow__1VKqK","total":"BalanceDue_total__2IKHX"};